import { useQuery } from '@tanstack/react-query';
import { getTokenBySession } from '@services/microservices/user.service';
import { useEffect, useRef, useState } from 'react';
import Cookies from 'js-cookie';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const usePreviousToken = (value: any) => {
  const ref = useRef();
  useEffect(() => {
    ref.current = value;
  });
  return ref.current;
};

export const useJwt = () => {
  const data = useQuery({
    queryKey: ['/me/jwt-token'],
    queryFn: getTokenBySession,
    refetchInterval: 8 * 60 * 60 * 1000, // automatically refetch after 8 hours
  });

  const previousToken = usePreviousToken(data.data?.token);
  const [renewToken, setRenewToken] = useState(false);

  useEffect(() => {
    const currentToken = data.data?.token;
    if (
      previousToken !== undefined &&
      currentToken !== previousToken &&
      currentToken !== ''
    ) {
      setRenewToken(true);
    } else {
      setRenewToken(false);
    }
  }, [data, previousToken]);

  return { data, renewToken };
};

export function useUserToken() {
  const uidFromCookies = () => Cookies.get('uid');

  const tokenFromCookies = () => Cookies.get('gbadmin_token');

  const [userToken] = useState<string | undefined>(tokenFromCookies());
  const [isTokenChanged, setTokenChanged] = useState(false);

  const [currentUid] = useState<string | undefined>(uidFromCookies());
  const [isUserChanged, setUserChanged] = useState(false);
  const [isUserLogout, setUserLogout] = useState(false);

  useEffect(() => {
    let intervalId = window.setInterval(() => {
      const newUid = uidFromCookies();
      if (newUid !== currentUid) {
        setUserChanged(true);
      } else {
        setUserChanged(false);
      }

      const newToken = tokenFromCookies();
      if (userToken !== newToken) {
        setTokenChanged(true);
      } else {
        setTokenChanged(false);
      }

      if (newUid === undefined || newToken === undefined) {
        setUserLogout(true);
      } else {
        setUserLogout(false);
      }
    }, 5000);

    return () => {
      window.clearInterval(intervalId);
    };
  }, [setUserChanged, setUserLogout, setTokenChanged]);

  return { isTokenChanged, isUserChanged, isUserLogout };
}
